export default {
  integer: "Please enter an integer",
  dataType: "The field does not have the required data type.",
  maxLength: "This fields value must be {field.maxLength} maximum.",
  minLength: "This fields value must be {field.minLength} minimum.",
  maxLowerMin: "The value must be greater the minimum value.",
  minHigherMax: "The value must be less than or equal to the maximum value.",
  required: "This field is mandatory",
  hasNoSwitchingOperation: "Switching operation is not allowed",
};
